import type { JSX } from "react";
export function Sprig(p: { tone?: "green" | "sand" | "sky" | "apricot"; className?: string }): JSX.Element {
  return <img aria-hidden="true" alt="" width={220} height={90} className={`qy-sprig ${p.className ?? ""}`} src={`/tianguang/sprig-web-${p.tone ?? "green"}.svg`} />;
}
